import { render, staticRenderFns } from "./WithdrawalLimit.vue?vue&type=template&id=e70207f2&"
import script from "./WithdrawalLimit.vue?vue&type=script&lang=js&"
export * from "./WithdrawalLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports